import { Button, Flex, Modal, Typography } from "antd";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { AiFillInfoCircle } from "react-icons/ai";

import { CopyButton } from "sandbox/features/shared";
import { AMP_BLOCK_CLASS } from "shell/api/amplitudePrivacy";

import s from "./RevealSecretModal.module.css";

interface RevealedCredential {
  clientId: string;
  clientSecret: string;
  name?: string;
}

interface RevealSecretModalProps {
  credential: RevealedCredential | null;
  isRotation?: boolean;
  onClose: () => void;
  open?: boolean;
}

export const RevealSecretModal = ({
  credential,
  isRotation,
  onClose,
  open,
}: RevealSecretModalProps) => {
  const { t } = useTranslation(["sandbox", "common"]);

  return (
    <Modal
      open={open}
      title={
        isRotation
          ? t("components.revealSecretModal.title.rotate")
          : t("components.newCredentialModal.title")
      }
      footer={
        <Button type="primary" onClick={onClose}>
          {t("components.revealSecretModal.copyAndClose")}
        </Button>
      }
      onCancel={onClose}
      closable
      mask={{ closable: false }}
      width={520}
    >
      {credential && (
        <Flex vertical gap="middle">
          {credential.name && (
            <Flex vertical gap={4}>
              <span className={s.fieldLabel}>
                {t("components.newCredentialModal.credentialName")}
              </span>
              <span className={s.fieldValue}>{credential.name}</span>
            </Flex>
          )}

          <Flex vertical gap={4}>
            <span className={s.fieldLabel}>{t("common:labels.clientId")}</span>
            <span className={s.fieldValue}>{credential.clientId}</span>
          </Flex>

          <Flex align="flex-start" gap="small" className={s.info}>
            <AiFillInfoCircle className={s.infoIcon} aria-hidden />
            <div>
              <Typography className={s.copyTitle}>
                {t("components.revealSecretModal.copyTitle")}
              </Typography>
              <Typography className={s.copyInfo}>
                {t("components.revealSecretModal.tokenExpiryInfo")}
              </Typography>
            </div>
          </Flex>

          <Flex vertical gap={4}>
            <span className={s.fieldLabel}>
              {t("components.revealSecretModal.secretKey")}
            </span>
            <Flex align="flex-start" gap="small" className={s.secretRow}>
              <code className={clsx(s.secretCode, AMP_BLOCK_CLASS)}>
                {credential.clientSecret}
              </code>
              <CopyButton
                value={credential.clientSecret}
                label={t("components.credentialCard.copySecret")}
                size="middle"
              />
            </Flex>
          </Flex>
        </Flex>
      )}
    </Modal>
  );
};
